import { useNavigate } from "react-router-dom";
import type { RecentSale } from "../types/dashboard.types";
import { AvatarBadge } from "./AvatarBadge";

interface RecentSalesCardProps {
	sales: RecentSale[];
}

export function RecentSalesCard({ sales }: RecentSalesCardProps) {
	const navigate = useNavigate();

	return (
		<div className="crm-card">
			<div className="crm-card-head">
				<h3>So'nggi sotuvlar</h3>
			</div>
			<div className="crm-card-body compact">
				{sales.map((sale) => (
					<div
						className="crm-list-row"
						key={sale.id}
						onClick={() =>
							navigate(
								`/sales/${sale.id.replace("sale-236", "sale-41").replace("sale-503", "sale-42").replace("sale-118", "sale-23")}`,
								{ state: { returnTo: "/dashboard", fromDashboard: true } }
							)
						}
						style={{ cursor: "pointer" }}
					>
						<AvatarBadge initials={sale.clientName.slice(0, 2).toUpperCase()} />
						<div>
							<strong>{sale.clientName}</strong>
							<span>xona {sale.room}</span>
						</div>
						<em>{sale.amount}</em>
					</div>
				))}
			</div>
		</div>
	);
}
